import { render } from "./import_daimianshi.vue?vue&type=template&id=4f6cb256&scoped=true"
import script from "./import_daimianshi.vue?vue&type=script&lang=js"
export * from "./import_daimianshi.vue?vue&type=script&lang=js"

import "./import_daimianshi.vue?vue&type=style&index=0&id=4f6cb256&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6cb256"]])

export default __exports__